import { render } from "./AccountInteractiveRicePanel.vue?vue&type=template&id=28c565e0"
import script from "./AccountInteractiveRicePanel.vue?vue&type=script&lang=js"
export * from "./AccountInteractiveRicePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__